import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { SubscriptionData } from "../../Models/Trainee";
import { Router } from "../../Handlers/Router";
import HRPage from "../../../Component/Admin/HRPage";
import Profile from "../../../Component/Client/Profile";

export class ClientSubscribeVM extends InterActive{
    private levelSpecializations:{id:string , price:string , name:string }[] = []
    private accounts:{id:string , name:string , banck_account_id:string , currency:{id:string , account:string , arabic_currency_name:string , english_currency_name:string , price:number } }[] = []
    private data:SubscriptionData={ id:'' , name:'' , levelSpecializations_id:'' ,account_id:'' , price:'', discount:'0' , paid:'0' , remainning:'' , verification:'verify', transffer_date:'' ,img:null , img_name:'' , additional:'' , notes:'' }
    private currencyPrice:number = 0
    private localPrice:number= 0

    public get Data():SubscriptionData{ return this.data }

    public get LevelSpecializations():{label:string , value:string }[] { return this.levelSpecializations.map(a=>({label:a.name , value:a.id}))}
    public get Accounts():{label:string , value:string }[] { return this.accounts.map(a=>({label:a.name , value:a.id})) }
    public get Price():string { return  this.data.price }
    public get LocalPrice():number{ return this.localPrice }
    public get CurrencyPrice():number { return this.currencyPrice }

    private clearImg:()=>void = ()=>{};
    public get ClearImg():()=>void{ return this.clearImg  }
    public set ClearImg(value:()=>void){ this.clearImg = value ; this.update()  }

    public set Specialization(value:string){ this.data.levelSpecializations_id = value; this.data.price = this.levelSpecializations.find(a=>a.id===value)?.price||''; this.calculateRemainning(); this.update() }
    public set Account(value:string ){ this.data.account_id = value; this.CurrencyPrice = this.accounts.find(a=>a.id===value)?.currency.price||0; this.data.paid = '0'; this.update() }
    //public set Discount(value:string){ this.data.discount = value?GeneralMethods.removeNonFloatNumeric(value):'0';  this.calculateRemainning(); this.update() }
    public set Discount(value:string){ this.data.discount =  Number(GeneralMethods.removeNonPositiveFloatNumeric(value))<0 ?'0':(Number(GeneralMethods.removeNonPositiveFloatNumeric(value)) > (this.localPrice)?(this.localPrice):GeneralMethods.removeNonPositiveFloatNumeric(value)).toString(); /*this.data.paid = Math.max((Number(GeneralMethods.removeNonPositiveFloatNumeric(value)) <= (this.localPrice-Number(this.data.discount))?Number(GeneralMethods.removeNonPositiveFloatNumeric(value)):(this.localPrice-Number(this.data.discount))),0).toString(); */this.calculateRemainning(); this.update()  }
    public set Verification(value:string){ this.data.verification = value; this.update() }
    public set Paid(value:string ){ this.data.paid = Number(GeneralMethods.removeNonPositiveFloatNumeric(value))<0 ?'0':(Number(GeneralMethods.removeNonPositiveFloatNumeric(value)) > (this.localPrice-Number(this.data.discount))?(this.localPrice-Number(this.data.discount)):GeneralMethods.removeNonPositiveFloatNumeric(value)).toString(); /*this.data.paid = Math.max((Number(GeneralMethods.removeNonPositiveFloatNumeric(value)) <= (this.localPrice-Number(this.data.discount))?Number(GeneralMethods.removeNonPositiveFloatNumeric(value)):(this.localPrice-Number(this.data.discount))),0).toString(); */this.calculateRemainning(); this.update() }
    public set Remainning(value:string) { this.data.remainning = GeneralMethods.removeNonFloatNumeric(value); this.update() }
    public set TransferDate(value:string) { this.data.transffer_date = value; this.update() }
    public set Img(value:File|null){ this.data.img = value ; this.update() }
    public set Additional(value:string) { this.data.additional = GeneralMethods.removeNonFloatNumeric(value); this.update() }
    public set Notes(value:string){ this.data.notes = value; this.update() }
    private set CurrencyPrice(value:number){ this.currencyPrice = value; this.localPrice = Math.ceil( Number(this.Price)*value *100)/100 }

    constructor(id:string ,name:string ){
        super()
        this.data.id = id
        this.data.name = name
        this.getLists()
    }

    private calculateRemainning(){
        if(this.data.price && this.data.paid && this.data.discount){
            const result = Number(this.data.price) - Number(this.data.discount) - Number(this.data.paid)
            this.data.remainning = result.toString()
            this.update()
        }
    }

    public getLists(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAccountsAndLevelSpecializations(this.data.id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.levelSpecializations = response.data.data.levelSpecializations
                                if(this.levelSpecializations.length>0)this.Specialization = this.levelSpecializations[0].id
                                this.accounts = response.data.data.accounts
                                if(this.accounts.length>0)this.Account = this.accounts[0].id
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                        }else  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }

    public send(){
        if(this.validate()){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.createSubscription(this.toFormData())
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    Router.OpenNormalPage(<Profile id={this.Data.id}/>)
                                    Notify({type:'success' , title:'عملية ناجحة' , body:'تم التسجيل بنجاح'})
                                }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                            }else Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخري'})
                        }
                        this.update()
                    }catch{
                        Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخري'})
                    }
                }
            )
        }
    }

    private validate(){
        if(!this.data.levelSpecializations_id){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء اختيار التخصص'}); return false; }
        if(!this.data.account_id){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء اختيار الحساب'}); return false; }
        if(!this.data.paid){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء ادخال المبلغ المدفوع'}); return false; }
        if(!this.data.transffer_date){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء ادخال تاريخ التحويل'}); return false; }
        if(this.data.img == null) { Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء ادخال صورة الايصال'}); return false; }
        return true;
    }

    private toFormData():FormData{
        const formData = new FormData()
        formData.append('id' , this.data.id)
        formData.append('levelSpecializations_id' , this.data.levelSpecializations_id)
        formData.append('level_specialization' , this.levelSpecializations.find(a=>a.id===this.data.levelSpecializations_id)?.name||'')
        formData.append('account_id' , this.data.account_id)
        formData.append('price' , this.data.price)
        formData.append('discount' , this.data.discount)
        formData.append('verification' , this.data.verification)
        formData.append('value' , this.data.paid)
        formData.append('transffer_date' , this.data.transffer_date)
        formData.append('additional',this.data.additional)
        formData.append('notes', this.data.notes)
        if(this.data.img)formData.append( 'img' , this.data.img)

        return formData
    }
}